export const loading = () => {
  return {
    type: "LOADING_ORDERS"
  };
};

export const success = () => {
  return {
    type: "SUCCESS_ON_ORDERS"
  };
};

//redux-thunk handles the async operations using dispatch, simply follow this pattern
export const getOrders = val => {
  return async dispatch => {
    dispatch(loading());
    let res = await (await fetch(`https://mosi-api.herokuapp.com/api/orders/${val}`, {
      headers: {
        'x-access-token': `${localStorage.getItem("token")}`
      },
    })).json();
    console.log(res);
    dispatch({
      type: "GET_USER_ORDERS",
      value: res.reverse()
    })
  };
};

export const addOrder = val => {
  return async dispatch => {
    dispatch(loading());

    let res;
    try {
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/orders`, {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`
        },
        body: JSON.stringify(val)
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_ORDERS" }) }

    console.log(res);
    dispatch(success());
    dispatch(getOrders(val.userId));
  };
  // return { type: "ADD_ORDER", value: val };
};

export const updateOrder = val => {
  return async dispatch => {
    dispatch(loading());

    let res;
    try {
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/orders/${val._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`
        },
        body: JSON.stringify(val)
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_ORDERS" }) }

    console.log(res);
    dispatch(success());
    dispatch(getOrders(val.userId));
  };
  // return { type: "ADD_ORDER", value: val };
};

export const fulfillOrder = val => {
  const orderStatus = val.fulfilled ? false : true;
  return async dispatch => {
    dispatch(loading());

    let res;
    try {
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/orders/${val._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`
        },
        body: JSON.stringify({ ...val, fulfilled: orderStatus })
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_ORDERS" }) }

    console.log(res);
    dispatch(success());
    dispatch(getOrders(val.userId));
  };
  // return { type: "ADD_ORDER", value: val };
};

export const cancelOrder = val => {
  const orderStatus = val.cancelled ? false : true;
  return async dispatch => {
    dispatch(loading());

    let res;
    try {
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/orders/${val._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': `${localStorage.getItem("token")}`
        },
        body: JSON.stringify({ ...val, cancelled: orderStatus })
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_ORDERS" }) }

    console.log(res);
    dispatch(success());
    dispatch(getOrders(val.userId));
  };
  // return { type: "ADD_ORDER", value: val };
};

export const removeOrder = val => {
  return async dispatch => {
    dispatch(loading());

    let res;
    try {
      res = await (await fetch(`https://mosi-api.herokuapp.com/api/orders/${val.orderId}`, {
        method: 'DELETE',
        headers: {
          'x-access-token': `${localStorage.getItem("token")}`
        },
      })).json();
    } catch (e) { console.log(e); return dispatch({ type: "ERROR_ON_ORDERS" }) }

    console.log(res);
    dispatch(success());
    window.location.reload();
  };
  // return { type: "ADD_ORDER", value: val };
};

export const resetStatus = () => {
  return { type: "RESET_ORDER_STATUS" };
};